import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar } from '@mui/material';
import Logo from './Logo';

const MainNavbar = (props) => (
  <AppBar
    elevation={0}
    sx={{background:"#FAF8F6"}}
    {...props}
  >
    <Toolbar sx={{ height: "70px !important", minHeight: "70px !important", background:"#FAF8F6", justifyContent:"center" }}>
      <RouterLink to="/">
        <Logo />
      </RouterLink>
    </Toolbar>
  </AppBar>
);

export default MainNavbar;
